export const getMessage = (message: string, lang: string) => {
  switch (message) {
    case "Service response successfully":
      switch (lang) {
        case "ES":
          return "¡Respuesta del servicio con éxito!";
        case "FR":
          return "Réponse du service avec succès!";
        case "DE":
          return "Dienstantwort erfolgreich!";
        case "IT":
          return "Risposta del servizio con successo!";
        default:
          return "Service response successfully!";
      }
    case "Successfully accepted company":
      switch (lang) {
        case "ES":
          return "¡Empresa aceptada con éxito!";
        case "FR":
          return "Entreprise acceptée avec succès!";
        case "DE":
          return "Unternehmen erfolgreich akzeptiert!";
        case "IT":
          return "Azienda accettata con successo!";
        default:
          return "Successfully accepted company!";
      }
    case "Successfully created treasury account":
      switch (lang) {
        case "ES":
          return "¡Cuenta de tesorería creada con éxito!";
        case "FR":
          return "Compte de trésorerie créé avec succès!";
        case "DE":
          return "Treasury-Konto erfolgreich erstellt!";
        case "IT":
          return "Conto di tesoreria creato con successo!";
        default:
          return "Successfully created treasury account!";
      }
    case "Successfully created company":
      switch (lang) {
        case "ES":
          return "¡Empresa creada con éxito!";
        case "FR":
          return "Entreprise créée avec succès!";
        case "DE":
          return "Unternehmen erfolgreich erstellt!";
        case "IT":
          return "Azienda creata con successo!";
        default:
          return "Successfully created company!";
      }
    case "Successfully created company parameters":
      switch (lang) {
        case "ES":
          return "¡Parámetros de empresa creados con éxito!";
        case "FR":
          return "Paramètres d'entreprise créés avec succès!";
        case "DE":
          return "Unternehmensparameter erfolgreich erstellt!";
        case "IT":
          return "Parametri dell'azienda creati con successo!";
        default:
          return "Successfully created company parameters!";
      }
    case "Successfully created contact":
      switch (lang) {
        case "ES":
          return "¡Contacto creado con éxito!";
        case "FR":
          return "Contact créé avec succès!";
        case "DE":
          return "Kontakt erfolgreich erstellt!";
        case "IT":
          return "Contatto creato con successo!";
        default:
          return "Successfully created contact!";
      }
    case "Successfully created expense":
      switch (lang) {
        case "ES":
          return "¡Gasto creado con éxito!";
        case "FR":
          return "Dépense créée avec succès!";
        case "DE":
          return "Ausgabe erfolgreich erstellt!";
        case "IT":
          return "Spesa creata con successo!";
        default:
          return "Successfully created expense!";
      }
    case "Successfully created order":
      switch (lang) {
        case "ES":
          return "¡Pedido creado con éxito!";
        case "FR":
          return "Commande créée avec succès!";
        case "DE":
          return "Bestellung erfolgreich erstellt!";
        case "IT":
          return "Ordine creato con successo!";
        default:
          return "Successfully created order!";
      }
    case "Successfully created invoice":
      switch (lang) {
        case "ES":
          return "¡Factura creada con éxito!";
        case "FR":
          return "Facture créée avec succès!";
        case "DE":
          return "Rechnung erfolgreich erstellt!";
        case "IT":
          return "Fattura creata con successo!";
        default:
          return "Successfully created invoice!";
      }
    case "Successfully created notification":
      switch (lang) {
        case "ES":
          return "¡Notificación creada con éxito!";
        case "FR":
          return "Notification créée avec succès!";
        case "DE":
          return "Benachrichtigung erfolgreich erstellt!";
        case "IT":
          return "Notifica creata con successo!";
        default:
          return "Successfully created notification!";
      }
    case "Successfully created payment":
      switch (lang) {
        case "ES":
          return "¡Pago creado con éxito!";
        case "FR":
          return "Paiement créé avec succès!";
        case "DE":
          return "Zahlung erfolgreich erstellt!";
        case "IT":
          return "Pagamento creato con successo!";
        default:
          return "Successfully created payment!";
      }
    case "Successfully created provider invoice":
      switch (lang) {
        case "ES":
          return "¡Factura de proveedor creada con éxito!";
        case "FR":
          return "Facture fournisseur créée avec succès!";
        case "DE":
          return "Lieferantenrechnung erfolgreich erstellt!";
        case "IT":
          return "Fattura fornitore creata con successo!";
        default:
          return "Successfully created provider invoice!";
      }
    case "Successfully created provider order":
      switch (lang) {
        case "ES":
          return "¡Pedido de proveedor creado con éxito!";
        case "FR":
          return "Commande fournisseur créée avec succès!";
        case "DE":
          return "Lieferantenbestellung erfolgreich erstellt!";
        case "IT":
          return "Ordine fornitore creato con successo!";
        default:
          return "Successfully created provider order!";
      }
    case "Successfully created quote":
      switch (lang) {
        case "ES":
          return "¡Cotización creada con éxito!";
        case "FR":
          return "Devis créé avec succès!";
        case "DE":
          return "Angebot erfolgreich erstellt!";
        case "IT":
          return "Preventivo creato con successo!";
        default:
          return "Successfully created quote!";
      }
    case "Successfully deleted treasury account":
      switch (lang) {
        case "ES":
          return "¡Cuenta de tesorería eliminada con éxito!";
        case "FR":
          return "Compte de trésorerie supprimé avec succès!";
        case "DE":
          return "Treasury-Konto erfolgreich gelöscht!";
        case "IT":
          return "Conto di tesoreria eliminato con successo!";
        default:
          return "Successfully deleted treasury account!";
      }
    case "Successfully deleted contact":
      switch (lang) {
        case "ES":
          return "¡Contacto eliminado con éxito!";
        case "FR":
          return "Contact supprimé avec succès!";
        case "DE":
          return "Kontakt erfolgreich gelöscht!";
        case "IT":
          return "Contatto eliminato con successo!";
        default:
          return "Successfully deleted contact!";
      }
    case "Successfully deleted expense":
      switch (lang) {
        case "ES":
          return "¡Gasto eliminado con éxito!";
        case "FR":
          return "Dépense supprimée avec succès!";
        case "DE":
          return "Ausgabe erfolgreich gelöscht!";
        case "IT":
          return "Spesa eliminata con successo!";
        default:
          return "Successfully deleted expense!";
      }
    case "Successfully deleted payment":
      switch (lang) {
        case "ES":
          return "¡Pago eliminado con éxito!";
        case "FR":
          return "Paiement supprimé avec succès!";
        case "DE":
          return "Zahlung erfolgreich gelöscht!";
        case "IT":
          return "Pagamento eliminato con successo!";
        default:
          return "Successfully deleted payment!";
      }
    case "Successfully invitation cancel":
      switch (lang) {
        case "ES":
          return "¡Invitación cancelada con éxito!";
        case "FR":
          return "Invitation annulée avec succès!";
        case "DE":
          return "Einladung erfolgreich storniert!";
        case "IT":
          return "Invito annullato con successo!";
        default:
          return "Successfully invitation cancel!";
      }
    case "Successfully invitation sent":
      switch (lang) {
        case "ES":
          return "¡Invitación enviada con éxito!";
        case "FR":
          return "Invitation envoyée avec succès!";
        case "DE":
          return "Einladung erfolgreich gesendet!";
        case "IT":
          return "Invito inviato con successo!";
        default:
          return "Successfully invitation sent!";
      }
    case "You have successfully logged in":
      switch (lang) {
        case "ES":
          return "¡Has iniciado sesión con éxito!";
        case "FR":
          return "Vous vous êtes connecté avec succès!";
        case "DE":
          return "Sie haben sich erfolgreich angemeldet!";
        case "IT":
          return "Hai effettuato il login con successo!";
        default:
          return "You have successfully logged in!";
      }
    case "Successfully order sent":
      switch (lang) {
        case "ES":
          return "¡Pedido enviado con éxito!";
        case "FR":
          return "Commande envoyée avec succès!";
        case "DE":
          return "Bestellung erfolgreich gesendet!";
        case "IT":
          return "Ordine inviato con successo!";
        default:
          return "Successfully order sent!";
      }
    case "Successfully updated company settings":
      switch (lang) {
        case "ES":
          return "¡Configuración de la empresa actualizada con éxito!";
        case "FR":
          return "Paramètres de l'entreprise mis à jour avec succès!";
        case "DE":
          return "Unternehmensparameter erfolgreich aktualisiert!";
        case "IT":
          return "Impostazioni aziendali aggiornate con successo!";
        default:
          return "Successfully updated company settings!";
      }
    case "Successfully updated treasury account":
      switch (lang) {
        case "ES":
          return "¡Cuenta de tesorería actualizada con éxito!";
        case "FR":
          return "Compte de trésorerie mis à jour avec succès!";
        case "DE":
          return "Treasury-Konto erfolgreich aktualisiert!";
        case "IT":
          return "Conto di tesoreria aggiornato con successo!";
        default:
          return "Successfully updated treasury account!";
      }
    case "Successfully updated default treasury account":
      switch (lang) {
        case "ES":
          return "¡Cuenta de tesorería predeterminada actualizada con éxito!";
        case "FR":
          return "Compte de trésorerie par défaut mis à jour avec succès!";
        case "DE":
          return "Standard-Treasury-Konto erfolgreich aktualisiert!";
        case "IT":
          return "Conto di tesoreria predefinito aggiornato con successo!";
        default:
          return "Successfully updated default treasury account!";
      }
    case "Successfully updated contact":
      switch (lang) {
        case "ES":
          return "¡Contacto actualizado con éxito!";
        case "FR":
          return "Contact mis à jour avec succès!";
        case "DE":
          return "Kontakt erfolgreich aktualisiert!";
        case "IT":
          return "Contatto aggiornato con successo!";
        default:
          return "Successfully updated contact!";
      }
    case "Successfully updated expense":
      switch (lang) {
        case "ES":
          return "¡Gasto actualizado con éxito!";
        case "FR":
          return "Dépense mise à jour avec succès!";
        case "DE":
          return "Ausgabe erfolgreich aktualisiert!";
        case "IT":
          return "Spesa aggiornata con successo!";
        default:
          return "Successfully updated expense!";
      }
    case "Successfully updated invoice":
      switch (lang) {
        case "ES":
          return "¡Factura actualizada con éxito!";
        case "FR":
          return "Facture mise à jour avec succès!";
        case "DE":
          return "Rechnung erfolgreich aktualisiert!";
        case "IT":
          return "Fattura aggiornata con successo!";
        default:
          return "Successfully updated invoice!";
      }
    case "Successfully updated notification":
      switch (lang) {
        case "ES":
          return "¡Notificación actualizada con éxito!";
        case "FR":
          return "Notification mise à jour avec succès!";
        case "DE":
          return "Benachrichtigung erfolgreich aktualisiert!";
        case "IT":
          return "Notifica aggiornata con successo!";
        default:
          return "Successfully updated notification!";
      }
    case "Successfully updated order":
      switch (lang) {
        case "ES":
          return "¡Pedido actualizado con éxito!";
        case "FR":
          return "Commande mise à jour avec succès!";
        case "DE":
          return "Bestellung erfolgreich aktualisiert!";
        case "IT":
          return "Ordine aggiornato con successo!";
        default:
          return "Successfully updated order!";
      }
    case "Successfully updated password":
      switch (lang) {
        case "ES":
          return "¡Contraseña actualizada con éxito!";
        case "FR":
          return "Mot de passe mis à jour avec succès!";
        case "DE":
          return "Passwort erfolgreich aktualisiert!";
        case "IT":
          return "Password aggiornato con successo!";
        default:
          return "Successfully updated password!";
      }
    case "Successfully updated provider invoice":
      switch (lang) {
        case "ES":
          return "¡Factura de proveedor actualizada con éxito!";
        case "FR":
          return "Facture fournisseur mise à jour avec succès!";
        case "DE":
          return "Lieferantenrechnung erfolgreich aktualisiert!";
        case "IT":
          return "Fattura fornitore aggiornata con successo!";
        default:
          return "Successfully updated provider invoice!";
      }
    case "Successfully updated provider order":
      switch (lang) {
        case "ES":
          return "¡Pedido de proveedor actualizado con éxito!";
        case "FR":
          return "Commande fournisseur mise à jour avec succès!";
        case "DE":
          return "Lieferantenbestellung erfolgreich aktualisiert!";
        case "IT":
          return "Ordine fornitore aggiornato con successo!";
        default:
          return "Successfully updated provider order!";
      }
    case "Successfully updated quote":
      switch (lang) {
        case "ES":
          return "¡Cotización actualizada con éxito!";
        case "FR":
          return "Devis mis à jour avec succès!";
        case "DE":
          return "Angebot erfolgreich aktualisiert!";
        case "IT":
          return "Preventivo aggiornato con successo!";
        default:
          return "Successfully updated quote!";
      }
    case "Successfully updated status":
      switch (lang) {
        case "ES":
          return "¡Estado actualizado con éxito!";
        case "FR":
          return "Statut mis à jour avec succès!";
        case "DE":
          return "Status erfolgreich aktualisiert!";
        case "IT":
          return "Stato aggiornato con successo!";
        default:
          return "Successfully updated status!";
      }
    case "Successfully quote sent":
      switch (lang) {
        case "ES":
          return "¡Cotización enviada con éxito!";
        case "FR":
          return "Devis envoyé avec succès!";
        case "DE":
          return "Angebot erfolgreich gesendet!";
        case "IT":
          return "Preventivo inviato con successo!";
        default:
          return "Successfully quote sent!";
      }
    case "Successfully rejected company":
      switch (lang) {
        case "ES":
          return "¡Empresa rechazada con éxito!";
        case "FR":
          return "Entreprise rejetée avec succès!";
        case "DE":
          return "Unternehmen erfolgreich abgelehnt!";
        case "IT":
          return "Azienda rifiutata con successo!";
        default:
          return "Successfully rejected company!";
      }
    case "Successful request":
      switch (lang) {
        case "ES":
          return "¡Solicitud exitosa!";
        case "FR":
          return "Demande réussie!";
        case "DE":
          return "Anfrage erfolgreich!";
        case "IT":
          return "Richiesta riuscita!";
        default:
          return "Successful request!";
      }
    case "Verification was successful":
      switch (lang) {
        case "ES":
          return "¡Verificación exitosa!";
        case "FR":
          return "Vérification réussie!";
        case "DE":
          return "Überprüfung war erfolgreich!";
        case "IT":
          return "Verifica riuscita!";
        default:
          return "Verification was successful!";
      }
    case "Successfully mail sent":
      switch (lang) {
        case "ES":
          return "¡Correo enviado con éxito!";
        case "FR":
          return "Courrier envoyé avec succès!";
        case "DE":
          return "E-Mail erfolgreich gesendet!";
        case "IT":
          return "Email inviato con successo!";
        default:
          return "Successfully mail sent!";
      }
    case "Successfully updated user":
      switch (lang) {
        case "ES":
          return "¡Usuario actualizado con éxito!";
        case "FR":
          return "Utilisateur mis à jour avec succès!";
        case "DE":
          return "Benutzer erfolgreich aktualisiert!";
        case "IT":
          return "Utente aggiornato con successo!";
        default:
          return "Successfully updated user!";
      }
    case "Successfully updated account":
      switch (lang) {
        case "ES":
          return "¡Cuenta actualizada con éxito!";
        case "FR":
          return "Compte mis à jour avec succès!";
        case "DE":
          return "Konto erfolgreich aktualisiert!";
        case "IT":
          return "Account aggiornato con successo!";
        default:
          return "Successfully updated account!";
      }
    case "Successfully subscribed":
      switch (lang) {
        case "ES":
          return "¡Suscripción realizada con éxito!";
        case "FR":
          return "Abonnement réussi!";
        case "DE":
          return "Erfolgreich abonniert!";
        case "IT":
          return "Iscrizione effettuata con successo!";
        default:
          return "Successfully subscribed!";
      }
    case "Successfully deleted categories":
      switch (lang) {
        case "ES":
          return "¡Categorías eliminadas con éxito!";
        case "FR":
          return "Catégories supprimées avec succès!";
        case "DE":
          return "Kategorien erfolgreich gelöscht!";
        case "IT":
          return "Categorie eliminate con successo!";
        default:
          return "Successfully deleted categories!";
      }
    case "Successfully created service":
      switch (lang) {
        case "ES":
          return "¡Servicio creado con éxito!";
        case "FR":
          return "Service créé avec succès!";
        case "DE":
          return "Dienst erfolgreich erstellt!";
        case "IT":
          return "Servizio creato con successo!";
        default:
          return "Successfully created service!";
      }
    case "Successfully updated service":
      switch (lang) {
        case "ES":
          return "¡Servicio actualizado con éxito!";
        case "FR":
          return "Service mis à jour avec succès!";
        case "DE":
          return "Dienst erfolgreich aktualisiert!";
        case "IT":
          return "Servizio aggiornato con successo!";
        default:
          return "Successfully updated service!";
      }
    case "Successfully updated product":
      switch (lang) {
        case "ES":
          return "¡Producto actualizado con éxito!";
        case "FR":
          return "Produit mis à jour avec succès!";
        case "DE":
          return "Produkt erfolgreich aktualisiert!";
        case "IT":
          return "Prodotto aggiornato con successo!";
        default:
          return "Successfully updated product!";
      }
    case "Successfully created product":
      switch (lang) {
        case "ES":
          return "¡Producto creado con éxito!";
        case "FR":
          return "Produit créé avec succès!";
        case "DE":
          return "Produkt erfolgreich erstellt!";
        case "IT":
          return "Prodotto creato con successo!";
        default:
          return "Successfully created product!";
      }
    case "Successfully deleted products":
      switch (lang) {
        case "ES":
          return "¡Productos eliminados con éxito!";
        case "FR":
          return "Produits supprimés avec succès!";
        case "DE":
          return "Produkte erfolgreich gelöscht!";
        case "IT":
          return "Prodotti eliminati con successo!";
        default:
          return "Successfully deleted products!";
      }
    case "Successfully created accounting entries":
      switch (lang) {
        case "ES":
          return "¡Entradas contables creadas exitosamente!";
        case "FR":
          return "Écritures comptables créées avec succès!";
        case "DE":
          return "Buchungssätze erfolgreich erstellt!";
        case "IT":
          return "Registrazioni contabili create con successo!";
        default:
          return "Successfully created accounting entries!";
      }
    case "Successfully updated accounting entries":
      switch (lang) {
        case "ES":
          return "¡Entradas contables actualizadas exitosamente!";
        case "FR":
          return "Écritures comptables mises à jour avec succès!";
        case "DE":
          return "Buchungssätze erfolgreich aktualisiert!";
        case "IT":
          return "Registrazioni contabili aggiornate con successo!";
        default:
          return "Successfully updated accounting entries!";
      }
    case "Successfully updated company parameters":
      switch (lang) {
        case "ES":
          return "¡Los parámetros de la compañía fueron actualizados exitosamente!";
        case "FR":
          return "Paramètres de l'entreprise mis à jour avec succès!";
        case "DE":
          return "Unternehmensparameter erfolgreich aktualisiert!";
        case "IT":
          return "Parametri dell'azienda aggiornati con successo!";
        default:
          return "Successfully updated company parameters!";
      }
    case "Successfully updated company":
      switch (lang) {
        case "ES":
          return "¡La compañía fue actualizada exitosamente!";
        case "FR":
          return "Entreprise mise à jour avec succès!";
        case "DE":
          return "Unternehmen erfolgreich aktualisiert!";
        case "IT":
          return "Azienda aggiornata con successo!";
        default:
          return "Successfully updated company!";
      }
    case "Successfully created booking journal":
      switch (lang) {
        case "ES":
          return "¡Diario de contabilidad creado con éxito!";
        case "FR":
          return "Journal de comptabilité créé avec succès!";
        case "DE":
          return "Buchungsjournal erfolgreich erstellt!";
        case "IT":
          return "Giornale di contabilità creato con successo!";
        default:
          return "Successfully created booking journal!";
      }
    case "Successfully verified account":
      switch (lang) {
        case "ES":
          return "¡Cuenta verificada con éxito!";
        case "FR":
          return "Compte vérifié avec succès!";
        case "DE":
          return "Konto erfolgreich verifiziert!";
        case "IT":
          return "Account verificato con successo!";
        default:
          return "Successfully verified account!";
      }
    case "Successfully created storage center":
      switch (lang) {
        case "ES":
          return "Centro de almacenamiento creado con éxito";
        case "FR":
          return "Centre de stockage créé avec succès";
        case "DE":
          return "Lagerzentrum erfolgreich erstellt";
        case "IT":
          return "Centro di stoccaggio creato con successo";
        default:
          return "Successfully created storage center";
      }
    case "Successfully deleted storage center":
      switch (lang) {
        case "ES":
          return "Centro de almacenamiento eliminado con éxito";
        case "FR":
          return "Centre de stockage supprimé avec succès";
        case "DE":
          return "Lagerzentrum erfolgreich gelöscht";
        case "IT":
          return "Centro di stoccaggio eliminato con successo";
        default:
          return "Successfully deleted storage center";
      }
    case "Successfully created storage operations":
      switch (lang) {
        case "ES":
          return "Operaciones de almacenamiento creadas con éxito";
        case "FR":
          return "Opérations de stockage créées avec succès";
        case "DE":
          return "Lageroperationen erfolgreich erstellt";
        case "IT":
          return "Operazioni di stoccaggio create con successo";
        default:
          return "Successfully created storage operations";
      }
    case "Successfully created POS":
      switch (lang) {
        case "ES":
          return "¡POS creado exitosamente!";
        case "FR":
          return "POS créé avec succès !";
        case "DE":
          return "POS erfolgreich erstellt!";
        case "IT":
          return "POS creato con successo!";
        default:
          return "Successfully created POS!";
      }
    case "Successfully deleted POS":
      switch (lang) {
        case "ES":
          return "¡POS eliminado exitosamente!";
        case "FR":
          return "POS supprimé avec succès !";
        case "DE":
          return "POS erfolgreich gelöscht!";
        case "IT":
          return "POS eliminato con successo!";
        default:
          return "Successfully deleted POS!";
      }
    case "Successfully created sale":
      switch (lang) {
        case "ES":
          return "¡Venta creada exitosamente!";
        case "FR":
          return "Vente créée avec succès !";
        case "DE":
          return "Verkauf erfolgreich erstellt!";
        case "IT":
          return "Vendita creata con successo!";
        default:
          return "Successfully created sale!";
      }
    case "Logged out successfully":
      switch (lang) {
        case "ES":
          return "¡Sesión cerrada correctamente!";
        case "FR":
          return "Déconnexion réussie !";
        case "DE":
          return "Erfolgreich abgemeldet!";
        case "IT":
          return "Disconnessione effettuata con successo!!";
        default:
          return "Logged out successfully!";
      }
    case "Notification archived":
      switch (lang) {
        case "ES":
          return "¡Notificación archivada!";
        case "FR":
          return "Notification archivée !";
        case "DE":
          return "Benachrichtigung archiviert!";
        case "IT":
          return "Notifica archiviata!";
        default:
          return "Notification archived!";
      }
    case "Notification marked as read":
      switch (lang) {
        case "ES":
          return "¡Notificación marcada como leída!";
        case "FR":
          return "Notification marquée comme lue !";
        case "DE":
          return "Benachrichtigung als gelesen markiert!";
        case "IT":
          return "Notifica contrassegnata come letta!";
        default:
          return "Notification marked as read!";
      }
    case "Notifications marked as read":
      switch (lang) {
        case "ES":
          return "¡Notificaciones marcadas como leídas!";
        case "FR":
          return "Notifications marquées comme lues !";
        case "DE":
          return "Benachrichtigungen als gelesen markiert!";
        case "IT":
          return "Notifiche contrassegnate come lette!";
        default:
          return "Notifications marked as read!";
      }
    case "Successfully created measure unit":
      switch (lang) {
        case "ES":
          return "¡Unidad de medida creada con éxito!";
        case "FR":
          return "Unité de mesure créée avec succès !";
        case "DE":
          return "Maßeinheit erfolgreich erstellt!";
        case "IT":
          return "Unità di misura creata con successo!";
        default:
          return "Successfully created measure unit!";
      }

    case "Successfully updated measure unit":
      switch (lang) {
        case "ES":
          return "¡Unidad de medida actualizada con éxito!";
        case "FR":
          return "Unité de mesure mise à jour avec succès !";
        case "DE":
          return "Maßeinheit erfolgreich aktualisiert!";
        case "IT":
          return "Unità di misura aggiornata con successo!";
        default:
          return "Successfully updated measure unit!";
      }

    case "Successfully deleted measure unit":
      switch (lang) {
        case "ES":
          return "¡Unidad de medida eliminada con éxito!";
        case "FR":
          return "Unité de mesure supprimée avec succès !";
        case "DE":
          return "Maßeinheit erfolgreich gelöscht!";
        case "IT":
          return "Unità di misura eliminata con successo!";
        default:
          return "Successfully deleted measure unit!";
      }
    case "Successfully created payment deadline":
      switch (lang) {
        case "ES":
          return "¡Plazo de pago creado con éxito!";
        case "FR":
          return "Délai de paiement créé avec succès !";
        case "DE":
          return "Zahlungsfrist erfolgreich erstellt!";
        case "IT":
          return "Scadenza di pagamento creata con successo!";
        default:
          return "Successfully created payment deadline!";
      }

    case "Successfully updated payment deadline":
      switch (lang) {
        case "ES":
          return "¡Plazo de pago actualizado con éxito!";
        case "FR":
          return "Délai de paiement mis à jour avec succès !";
        case "DE":
          return "Zahlungsfrist erfolgreich aktualisiert!";
        case "IT":
          return "Scadenza di pagamento aggiornata con successo!";
        default:
          return "Successfully updated payment deadline!";
      }

    case "Successfully deleted payment deadline":
      switch (lang) {
        case "ES":
          return "¡Plazo de pago eliminado con éxito!";
        case "FR":
          return "Délai de paiement supprimé avec succès !";
        case "DE":
          return "Zahlungsfrist erfolgreich gelöscht!";
        case "IT":
          return "Scadenza di pagamento eliminata con successo!";
        default:
          return "Successfully deleted payment deadline!";
      }
    case "Successfully created feature":
      switch (lang) {
        case "ES":
          return "¡Característica creada con éxito!";
        case "FR":
          return "Fonctionnalité créée avec succès !";
        case "DE":
          return "Funktion erfolgreich erstellt!";
        case "IT":
          return "Funzionalità creata con successo!";
        default:
          return "Successfully created feature!";
      }

    case "Successfully updated feature":
      switch (lang) {
        case "ES":
          return "¡Característica actualizada con éxito!";
        case "FR":
          return "Fonctionnalité mise à jour avec succès !";
        case "DE":
          return "Funktion erfolgreich aktualisiert!";
        case "IT":
          return "Funzionalità aggiornata con successo!";
        default:
          return "Successfully updated feature!";
      }

    case "Successfully deleted feature":
      switch (lang) {
        case "ES":
          return "¡Característica eliminada con éxito!";
        case "FR":
          return "Fonctionnalité supprimée avec succès !";
        case "DE":
          return "Funktion erfolgreich gelöscht!";
        case "IT":
          return "Funzionalità eliminata con successo!";
        default:
          return "Successfully deleted feature!";
      }
    case "Successfully created brand":
      switch (lang) {
        case "ES":
          return "¡Marca creada con éxito!";
        case "FR":
          return "Marque créée avec succès !";
        case "DE":
          return "Marke erfolgreich erstellt!";
        case "IT":
          return "Marchio creato con successo!";
        default:
          return "Successfully created brand!";
      }

    case "Successfully updated brand":
      switch (lang) {
        case "ES":
          return "¡Marca actualizada con éxito!";
        case "FR":
          return "Marque mise à jour avec succès !";
        case "DE":
          return "Marke erfolgreich aktualisiert!";
        case "IT":
          return "Marchio aggiornato con successo!";
        default:
          return "Successfully updated brand!";
      }

    case "Successfully deleted brand":
      switch (lang) {
        case "ES":
          return "¡Marca eliminada con éxito!";
        case "FR":
          return "Marque supprimée avec succès !";
        case "DE":
          return "Marke erfolgreich gelöscht!";
        case "IT":
          return "Marchio eliminato con successo!";
        default:
          return "Successfully deleted brand!";
      }
    default:
      if (message) return message;
      switch (lang) {
        case "ES": return "¡Operación realizada con éxito!";
        case "FR": return "Opération réussie!";
        case "DE": return "Vorgang erfolgreich!";
        case "IT": return "Operazione riuscita!";
        default:   return "Operation successful!";
      }
  }
};

export const getError = (code: any, lang: string, fallbackMessage?: string) => {
  switch (code) {
    case "ERROR_CODE":
      switch (lang) {
        case "ES": return "¡Error de respuesta del servicio!";
        case "FR": return "Erreur de réponse du service!";
        case "DE": return "Fehler bei der Dienstantwort!";
        case "IT": return "Errore nella risposta del servizio!";
        default: return "Service response error!";
      }
    case 'INTERNAL_DATABASE_ERROR':
      switch (lang) {
        case "ES": return "¡Error ocurrido en la base de datos!";
        case "FR": return "Une erreur s'est produite dans la base de données!";
        case "DE": return "Fehler in der Datenbank aufgetreten!";
        case "IT": return "Errore nel database!";
        default:   return "Error occurred in database!";
      }
    case 'VALIDATION_EMPTY_FIELD':
      switch (lang) {
        case "ES": return "¡Uno o más campos obligatorios están vacíos!";
        case "FR": return "Un ou plusieurs champs obligatoires sont vides!";
        case "DE": return "Ein oder mehrere Pflichtfelder sind leer!";
        case "IT": return "Uno o più campi obbligatori sono vuoti!";
        default:   return "One or more mandatory fields are empty!";
      }
    case 'VALIDATION_INVALID_ID':
      switch (lang) {
        case "ES": return "¡Formato inválido para el ID de la empresa!";
        case "FR": return "Format invalide pour l'identifiant de l'entreprise!";
        case "DE": return "Ungültiges Format für die Unternehmens-ID!";
        case "IT": return "Formato non valido per l'ID dell'azienda!";
        default:   return "Invalid format for company ID!";
      }
    case 'VALIDATION_INVALID_SORT':
      switch (lang) {
        case "ES": return "¡Modo de ordenación incorrecto!";
        case "FR": return "Mode de tri incorrect!";
        case "DE": return "Ungültige Sortierreihenfolge!";
        case "IT": return "Modalità di ordinamento non valida!";
        default:   return "Incorrect sort mode!";
      }
    case 'VALIDATION_PASSWORD_LENGTH':
      switch (lang) {
        case "ES": return "¡La contraseña debe tener al menos 8 caracteres!";
        case "FR": return "Le mot de passe doit comporter au moins 8 caractères!";
        case "DE": return "Das Passwort muss mindestens 8 Zeichen lang sein!";
        case "IT": return "La password deve contenere almeno 8 caratteri!";
        default:   return "Password must be at least 8 characters!";
      }
    case 'VALIDATION_INVALID_FORMAT':
      switch (lang) {
        case "ES": return "¡Formato inválido!";
        case "FR": return "Format invalide!";
        case "DE": return "Ungültiges Format!";
        case "IT": return "Formato non valido!";
        default:   return "Invalid format!";
      }
    case 'VALIDATION_INVALID_LANGUAGE':
      switch (lang) {
        case "ES": return "¡Formato de idioma inválido!";
        case "FR": return "Format de langue invalide!";
        case "DE": return "Ungültiges Sprachformat!";
        case "IT": return "Formato lingua non valido!";
        default:   return "Invalid format for language!";
      }
    case 'VALIDATION_PASSWORD_MISMATCH':
      switch (lang) {
        case "ES": return "¡Las contraseñas no coinciden!";
        case "FR": return "Les mots de passe ne correspondent pas!";
        case "DE": return "Die Passwörter stimmen nicht überein!";
        case "IT": return "Le password non corrispondono!";
        default:   return "Passwords do not match!";
      }
    case 'VALIDATION_PASSWORD_SAME':
      switch (lang) {
        case "ES": return "¡La nueva contraseña es igual a la contraseña actual!";
        case "FR": return "Le nouveau mot de passe est identique au mot de passe actuel!";
        case "DE": return "Das neue Passwort ist dasselbe wie das aktuelle Passwort!";
        case "IT": return "La nuova password è uguale a quella attuale!";
        default:   return "The new password is the same as the current password!";
      }
    case 'VALIDATION_EMAIL_SAME':
      switch (lang) {
        case "ES": return "¡El nuevo correo es igual al correo actual!";
        case "FR": return "Le nouvel e-mail est identique à l'e-mail actuel!";
        case "DE": return "Die neue E-Mail ist dieselbe wie die aktuelle E-Mail!";
        case "IT": return "La nuova email è uguale a quella attuale!";
        default:   return "The new email is the same as the current email!";
      }
    case 'VALIDATION_EMAIL_TAKEN':
      switch (lang) {
        case "ES": return "¡El correo electrónico ya está en uso!";
        case "FR": return "L'adresse e-mail est déjà utilisée!";
        case "DE": return "Diese E-Mail-Adresse ist bereits vergeben!";
        case "IT": return "L'email è già in uso!";
        default:   return "Email already taken!";
      }
    case 'AUTH_INVALID_API_KEY':
      switch (lang) {
        case "ES": return "¡Clave de API inválida!";
        case "FR": return "Clé API invalide!";
        case "DE": return "Ungültiger API-Schlüssel!";
        case "IT": return "Chiave API non valida!";
        default:   return "Invalid API key!";
      }
    case 'USER_NOT_FOUND':
      switch (lang) {
        case "ES": return "¡Usuario no encontrado!";
        case "FR": return "Utilisateur introuvable!";
        case "DE": return "Benutzer nicht gefunden!";
        case "IT": return "Utente non trovato!";
        default:   return "User not found!";
      }
    case 'COMPANY_NOT_FOUND':
      switch (lang) {
        case "ES": return "¡Empresa no encontrada!";
        case "FR": return "Entreprise introuvable!";
        case "DE": return "Unternehmen nicht gefunden!";
        case "IT": return "Azienda non trovata!";
        default:   return "Company not found!";
      }
    case 'COMPANY_ALREADY_EXISTS':
      switch (lang) {
        case "ES": return "¡Esta empresa ya está registrada!";
        case "FR": return "Cette entreprise est déjà enregistrée!";
        case "DE": return "Dieses Unternehmen ist bereits registriert!";
        case "IT": return "Questa azienda è già registrata!";
        default:   return "This company is already registered!";
      }
    case 'UUID_NOT_FOUND':
      switch (lang) {
        case "ES": return "¡UUID no encontrado!";
        case "FR": return "UUID introuvable!";
        case "DE": return "UUID nicht gefunden!";
        case "IT": return "UUID non trovato!";
        default:   return "UUID not found!";
      }
    case 'AUTH_INVALID_VERIFICATION_TOKEN':
      switch (lang) {
        case "ES": return "¡Token de verificación incorrecto!";
        case "FR": return "Jeton de vérification incorrect!";
        case "DE": return "Ungültiger Verifizierungstoken!";
        case "IT": return "Token di verifica non valido!";
        default:   return "Wrong verification token!";
      }
    case 'AUTH_INVALID_PASSWORD_TOKEN':
      switch (lang) {
        case "ES": return "¡Token de contraseña incorrecto!";
        case "FR": return "Jeton de mot de passe incorrect!";
        case "DE": return "Ungültiger Passwort-Token!";
        case "IT": return "Token della password non valido!";
        default:   return "Wrong password token!";
      }
    case 'USER_ALREADY_VERIFIED':
      switch (lang) {
        case "ES": return "¡El usuario ya está verificado!";
        case "FR": return "L'utilisateur est déjà vérifié!";
        case "DE": return "Der Benutzer ist bereits verifiziert!";
        case "IT": return "L'utente è già verificato!";
        default:   return "User is already verified!";
      }
    case 'SERVICE_ALREADY_SUBSCRIBED':
      switch (lang) {
        case "ES": return "¡El usuario ya está suscrito a este servicio!";
        case "FR": return "L'utilisateur est déjà abonné à ce service!";
        case "DE": return "Der Benutzer ist diesem Dienst bereits abonniert!";
        case "IT": return "L'utente è già abbonato a questo servizio!";
        default:   return "User is already subscribed to this service!";
      }
    case 'INVITE_NOT_FOUND':
      switch (lang) {
        case "ES": return "¡Invitación no encontrada!";
        case "FR": return "Invitation introuvable!";
        case "DE": return "Einladung nicht gefunden!";
        case "IT": return "Invito non trovato!";
        default:   return "Invitation not found!";
      }
    case 'INVITE_EXPIRED':
      switch (lang) {
        case "ES": return "¡La invitación ha expirado!";
        case "FR": return "L'invitation a expiré!";
        case "DE": return "Die Einladung ist abgelaufen!";
        case "IT": return "L'invito è scaduto!";
        default:   return "Invitation has expired!";
      }
    case 'INVITE_ALREADY_ACCEPTED':
      switch (lang) {
        case "ES": return "¡La invitación ya fue aceptada!";
        case "FR": return "L'invitation a déjà été acceptée!";
        case "DE": return "Die Einladung wurde bereits angenommen!";
        case "IT": return "L'invito è già stato accettato!";
        default:   return "Invitation has already been accepted!";
      }
    case 'INVITE_REVOKED':
      switch (lang) {
        case "ES": return "¡La invitación ha sido revocada!";
        case "FR": return "L'invitation a été révoquée!";
        case "DE": return "Die Einladung wurde widerrufen!";
        case "IT": return "L'invito è stato revocato!";
        default:   return "Invitation has been revoked!";
      }
    case 'INVITE_DUPLICATE':
      switch (lang) {
        case "ES": return "¡Ya existe una invitación pendiente para este correo en esta empresa!";
        case "FR": return "Une invitation en attente existe déjà pour cet e-mail dans cette entreprise!";
        case "DE": return "Für diese E-Mail in diesem Unternehmen existiert bereits eine ausstehende Einladung!";
        case "IT": return "Esiste già un invito in sospeso per questa email in questa azienda!";
        default:   return "A pending invitation already exists for this email in this company!";
      }
    case 'INVITE_SELF':
      switch (lang) {
        case "ES": return "¡No puedes invitarte a ti mismo!";
        case "FR": return "Vous ne pouvez pas vous inviter vous-même!";
        case "DE": return "Du kannst dich nicht selbst einladen!";
        case "IT": return "Non puoi invitare te stesso!";
        default:   return "Cannot invite yourself!";
      }
    case 'INVITE_ALREADY_MEMBER':
      switch (lang) {
        case "ES": return "¡El usuario ya es miembro de esta empresa!";
        case "FR": return "L'utilisateur est déjà membre de cette entreprise!";
        case "DE": return "Der Benutzer ist bereits Mitglied dieses Unternehmens!";
        case "IT": return "L'utente è già membro di questa azienda!";
        default:   return "User is already a member of this company!";
      }
    case 'INVITE_REQUIRES_REGISTRATION':
      switch (lang) {
        case "ES": return "¡Esta invitación requiere crear una cuenta. Usa el enlace de registro!";
        case "FR": return "Cette invitation nécessite la création d'un compte. Utilisez le lien d'inscription!";
        case "DE": return "Diese Einladung erfordert die Erstellung eines Kontos. Verwende den Registrierungslink!";
        case "IT": return "Questo invito richiede la creazione di un account. Usa il link di registrazione!";
        default:   return "This invitation requires account creation. Use the registration link!";
      }
    case 'EMAIL_ALREADY_EXISTS':
      switch (lang) {
        case "ES": return "¡Ya existe una cuenta con este correo electrónico!";
        case "FR": return "Un compte avec cet e-mail existe déjà!";
        case "DE": return "Ein Konto mit dieser E-Mail-Adresse existiert bereits!";
        case "IT": return "Esiste già un account con questa email!";
        default:   return "An account with this email already exists!";
      }
    case 'INVITE_NOT_FOR_NEW_USER':
      switch (lang) {
        case "ES": return "¡Esta invitación es para un usuario existente. Usa el endpoint de aceptación!";
        case "FR": return "Cette invitation est destinée à un utilisateur existant. Utilisez le point de terminaison d'acceptation!";
        case "DE": return "Diese Einladung ist für einen bestehenden Benutzer. Verwende den Akzeptieren-Endpunkt!";
        case "IT": return "Questo invito è per un utente esistente. Usa l'endpoint di accettazione!";
        default:   return "This invitation is for an existing user. Use the accept endpoint!";
      }
    case 'COMPANY_ACCESS_DENIED':
      switch (lang) {
        case "ES": return "¡No eres miembro de esta empresa!";
        case "FR": return "Vous n'êtes pas membre de cette entreprise!";
        case "DE": return "Du bist kein Mitglied dieses Unternehmens!";
        case "IT": return "Non sei membro di questa azienda!";
        default:   return "Not a member of this company!";
      }
    case 'RBAC_ROLE_NOT_FOUND':
      switch (lang) {
        case "ES": return "¡Rol no encontrado!";
        case "FR": return "Rôle introuvable!";
        case "DE": return "Rolle nicht gefunden!";
        case "IT": return "Ruolo non trovato!";
        default:   return "Role not found!";
      }
    case 'RBAC_POLICY_NOT_FOUND':
      switch (lang) {
        case "ES": return "¡Política no encontrada!";
        case "FR": return "Politique introuvable!";
        case "DE": return "Richtlinie nicht gefunden!";
        case "IT": return "Policy non trovata!";
        default:   return "Policy not found!";
      }
    case 'RBAC_ACCESS_DENIED':
      switch (lang) {
        case "ES": return "¡Acceso denegado!";
        case "FR": return "Accès refusé!";
        case "DE": return "Zugriff verweigert!";
        case "IT": return "Accesso negato!";
        default:   return "Access denied!";
      }
    case 'RBAC_ROLE_EXISTS':
      switch (lang) {
        case "ES": return "¡Ya existe un rol con este nombre en la empresa!";
        case "FR": return "Un rôle avec ce nom existe déjà dans cette entreprise!";
        case "DE": return "Eine Rolle mit diesem Namen existiert bereits in diesem Unternehmen!";
        case "IT": return "Esiste già un ruolo con questo nome nell'azienda!";
        default:   return "A role with this name already exists in this company!";
      }
    case 'RBAC_POLICY_EXISTS':
      switch (lang) {
        case "ES": return "¡Ya existe una política con este nombre en la empresa!";
        case "FR": return "Une politique avec ce nom existe déjà dans cette entreprise!";
        case "DE": return "Eine Richtlinie mit diesem Namen existiert bereits in diesem Unternehmen!";
        case "IT": return "Esiste già una policy con questo nome nell'azienda!";
        default:   return "A policy with this name already exists in this company!";
      }
    case 'RBAC_SYSTEM_ROLE_PROTECTED':
      switch (lang) {
        case "ES": return "¡Los roles del sistema no pueden ser modificados ni eliminados!";
        case "FR": return "Les rôles système ne peuvent pas être modifiés ni supprimés!";
        case "DE": return "Systemrollen können nicht geändert oder gelöscht werden!";
        case "IT": return "I ruoli di sistema non possono essere modificati o eliminati!";
        default:   return "System roles cannot be modified or deleted!";
      }
    case 'RBAC_ASSIGNMENT_EXISTS':
      switch (lang) {
        case "ES": return "¡El usuario ya tiene este rol en este ámbito!";
        case "FR": return "L'utilisateur a déjà ce rôle dans cette portée!";
        case "DE": return "Der Benutzer hat diese Rolle bereits in diesem Bereich!";
        case "IT": return "L'utente ha già questo ruolo in questo ambito!";
        default:   return "User already has this role in this scope!";
      }
    case 'RBAC_ASSIGNMENT_NOT_FOUND':
      switch (lang) {
        case "ES": return "¡Asignación de rol no encontrada!";
        case "FR": return "Affectation de rôle introuvable!";
        case "DE": return "Rollenzuweisung nicht gefunden!";
        case "IT": return "Assegnazione del ruolo non trovata!";
        default:   return "Role assignment not found!";
      }
    case 'SUB_REQUIRED':
      switch (lang) {
        case "ES": return "¡Se requiere una suscripción activa!";
        case "FR": return "Un abonnement actif est requis!";
        case "DE": return "Ein aktives Abonnement ist erforderlich!";
        case "IT": return "È richiesto un abbonamento attivo!";
        default:   return "Active subscription required!";
      }
    case 'SUB_EXPIRED':
      switch (lang) {
        case "ES": return "¡La suscripción ha expirado!";
        case "FR": return "L'abonnement a expiré!";
        case "DE": return "Das Abonnement ist abgelaufen!";
        case "IT": return "L'abbonamento è scaduto!";
        default:   return "Subscription expired!";
      }
    case 'SUB_PAST_DUE':
      switch (lang) {
        case "ES": return "¡Pago vencido!";
        case "FR": return "Paiement en retard!";
        case "DE": return "Zahlung überfällig!";
        case "IT": return "Pagamento scaduto!";
        default:   return "Payment overdue!";
      }
    case 'SUB_EXISTS':
      switch (lang) {
        case "ES": return "¡Ya existe una suscripción activa para este servicio!";
        case "FR": return "Un abonnement actif existe déjà pour ce service!";
        case "DE": return "Ein aktives Abonnement für diesen Dienst existiert bereits!";
        case "IT": return "Esiste già un abbonamento attivo per questo servizio!";
        default:   return "An active subscription already exists for this service!";
      }
    case 'SUB_NOT_FOUND':
      switch (lang) {
        case "ES": return "¡Suscripción no encontrada!";
        case "FR": return "Abonnement introuvable!";
        case "DE": return "Abonnement nicht gefunden!";
        case "IT": return "Abbonamento non trovato!";
        default:   return "Subscription not found!";
      }
    case 'PLAN_NOT_FOUND':
      switch (lang) {
        case "ES": return "¡Plan no encontrado!";
        case "FR": return "Plan introuvable!";
        case "DE": return "Plan nicht gefunden!";
        case "IT": return "Piano non trovato!";
        default:   return "Plan not found!";
      }
    case 'QUOTA_EXCEEDED':
      switch (lang) {
        case "ES": return "¡Cuota excedida!";
        case "FR": return "Quota dépassé!";
        case "DE": return "Kontingent überschritten!";
        case "IT": return "Quota superata!";
        default:   return "Quota exceeded!";
      }
    case 'FEATURE_NOT_AVAILABLE':
      switch (lang) {
        case "ES": return "¡Función no disponible!";
        case "FR": return "Fonctionnalité non disponible!";
        case "DE": return "Funktion nicht verfügbar!";
        case "IT": return "Funzionalità non disponibile!";
        default:   return "Feature not available!";
      }
    case 'ADDON_NOT_FOUND':
      switch (lang) {
        case "ES": return "¡Complemento no encontrado!";
        case "FR": return "Module complémentaire introuvable!";
        case "DE": return "Add-on nicht gefunden!";
        case "IT": return "Add-on non trovato!";
        default:   return "Add-on not found!";
      }
    case 'ADDON_INCOMPATIBLE':
      switch (lang) {
        case "ES": return "¡El complemento no es compatible con el plan actual!";
        case "FR": return "Le module complémentaire n'est pas compatible avec le plan actuel!";
        case "DE": return "Das Add-on ist mit dem aktuellen Plan nicht kompatibel!";
        case "IT": return "L'add-on non è compatibile con il piano attuale!";
        default:   return "Add-on is not compatible with current plan!";
      }
    case 'ADDON_ALREADY_ACTIVE':
      switch (lang) {
        case "ES": return "¡El complemento ya está activo en esta suscripción!";
        case "FR": return "Le module complémentaire est déjà actif sur cet abonnement!";
        case "DE": return "Das Add-on ist bereits in diesem Abonnement aktiv!";
        case "IT": return "L'add-on è già attivo su questo abbonamento!";
        default:   return "Add-on is already active on this subscription!";
      }
    case 'ADDON_NOT_ACTIVE':
      switch (lang) {
        case "ES": return "¡El complemento no está activo en esta suscripción!";
        case "FR": return "Le module complémentaire n'est pas actif sur cet abonnement!";
        case "DE": return "Das Add-on ist in diesem Abonnement nicht aktiv!";
        case "IT": return "L'add-on non è attivo su questo abbonamento!";
        default:   return "Add-on is not active on this subscription!";
      }
    case 'ADMIN_ACCESS_DENIED':
      switch (lang) {
        case "ES": return "¡Acceso de administrador denegado!";
        case "FR": return "Accès administrateur refusé!";
        case "DE": return "Administratorzugriff verweigert!";
        case "IT": return "Accesso amministratore negato!";
        default:   return "Admin access denied!";
      }
    case 'INTERNAL_ACCESS_DENIED':
      switch (lang) {
        case "ES": return "¡Acceso interno denegado!";
        case "FR": return "Accès interne refusé!";
        case "DE": return "Interner Zugriff verweigert!";
        case "IT": return "Accesso interno negato!";
        default:   return "Internal access denied!";
      }
    case 'INVITE_ROLE_FORBIDDEN':
      switch (lang) {
        case "ES": return "¡Su rol no le permite asignar este rol!";
        case "FR": return "Votre rôle ne vous permet pas d'attribuer ce rôle !";
        case "DE": return "Ihre Rolle erlaubt es nicht, diese Rolle zuzuweisen!";
        case "IT": return "Il tuo ruolo non ti consente di assegnare questo ruolo!";
        default:   return "Your role does not allow assigning this role!";
      }
    default:
      if (fallbackMessage) return fallbackMessage;
      switch (lang) {
        case "ES": return "¡Se ha producido un error!";
        case "FR": return "Une erreur est survenue!";
        case "DE": return "Ein Fehler ist aufgetreten!";
        case "IT": return "Si è verificato un errore!";
        default:   return "An error occurred!";
      }
  }
};
